import * as React from "react";
import "./tag.scss";
import classNames from "classnames";
import Icon from "atoms/icons/icon";
import { Tooltip } from "antd";
import { usePopupParent } from "hooks/usePopupParent";

type Item = {
  value: string;
  isLocked?: boolean;
};

interface TagProps {
  type?: "primary" | "secondary" | "tertiary";
  item?: Item;
  tooltipText?: React.ReactNode;
  onRemove?: () => void;
  onClose?: (item?: Item) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  children?: React.ReactNode;
}

const Tag: React.FC<TagProps> = ({
  type = "primary",
  onClose,
  item,
  onClick,
  tooltipText,
  children,
}) => {
  const classes = classNames("tag", { [`tag--${type}`]: true });
  const getPopupParent = usePopupParent("full-screen");

  const handleOnClose = React.useCallback(
    (e: React.MouseEvent) => {
      if (onClose) {
        onClose(item);
      }
      e.stopPropagation();
    },
    [item, onClose]
  );

  if (item?.isLocked) return null;

  return (
    <Tooltip
      getPopupContainer={getPopupParent}
      overlayClassName="tag-tooltip"
      placement="rightBottom"
      arrowPointAtCenter
      title={tooltipText || children}
    >
      <div className={classes} onClick={onClick}>
        <div>{children}</div>
        <div style={{ marginLeft: "10px" }}>
          <Icon
            faAlias="faTimes"
            onClick={handleOnClose}
            isActive
            type="tertiary"
            size="tiny"
          />
        </div>
      </div>
    </Tooltip>
  );
};

export default Tag;
